export const updateDeepProperty = (object, path, value) => {
    const newObject = Object.assign({}, object);
    const pathArray = Array.isArray(path) ? path : path.split('.');
    const last = pathArray[pathArray.length - 1];
    pathArray.reduce((subObject, prop) => {
        // eslint-disable-next-line
        subObject[prop] = prop === last ? value : { ...(subObject[prop] || {}) };
        return subObject[prop];
    }, newObject);
    return newObject;
};
